// Utility to scroll to top of the page
export function scrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}
